import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { FlavorFinderConsent } from "../Consent/FlavorFinderConsent";
import { FlavorFinderIntro } from "../Intro/FlavorFinderIntro";
import { FlavorFinderOptionalQuestion } from "../OptionalQuestion/FlavorFinderOptionalQuestion";
import { useFlavorFinderContext } from "../Provider/FlavorFinderContextProvider";
import { FlavorFinderQuestion } from "../Question/FlavorFinderQuestion";
import { FlavorFinderResults } from "../Results/FlavorFinderResults";
export const FlavorFinderViewSwitch = () => {
    const { flavorFinderData, currentQuestion, currentView, currentQuestionIndex, quizResult } = useFlavorFinderContext();
    const { nextCtaLabel, backCtaLabel, questionNumberIndicator, selectionIndicator, totalNumberOfQuestions, finalQuestion, skipCtaLabel, hideNextButton, } = flavorFinderData;
    useEffect(() => {
        if (currentView === "results")
            return;
        const stepIncrements = {
            consent: 2,
            results: 3,
        };
        const flavor_finder_step_number = currentQuestionIndex + (stepIncrements[currentView] || 1);
        dispatchTrackingEvent(TrackingEvents.TrackingFlavorFinderProgress, {
            flavor_finder_step_name: currentView === "question" ? currentQuestion?.question?.title || currentView : currentView,
            flavor_finder_step_number,
        });
    }, [currentView, currentQuestion, currentQuestionIndex]);
    switch (currentView) {
        case "intro":
            return _jsx(FlavorFinderIntro, {});
        case "question":
            return (currentQuestion && (_jsx(FlavorFinderQuestion, { question: currentQuestion, backCtaLabel: backCtaLabel, nextCtaLabel: nextCtaLabel, questionNumberIndicator: questionNumberIndicator, selectionIndicator: selectionIndicator, totalNumberOfQuestions: totalNumberOfQuestions, hideNextButton: hideNextButton })));
        case "optional":
            return finalQuestion ? (_jsx(FlavorFinderOptionalQuestion, { question: finalQuestion, skipCtaLabel: skipCtaLabel, nextCtaLabel: nextCtaLabel, backCtaLabel: backCtaLabel, selectionIndicator: selectionIndicator, hideNextButton: hideNextButton })) : null;
        case "consent":
            return _jsx(FlavorFinderConsent, {});
        case "results":
            return _jsx(FlavorFinderResults, { results: quizResult });
    }
};
//# sourceMappingURL=FlavorFinderViewSwitch.js.map